import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LaserficheTrustee } from '../_models/laserfiche-trustee.model';
import { NgForm } from '@angular/forms';
import { first } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { trigger, style, animate, transition } from '@angular/animations';

import { LaserficheAdminService } from '../_services/laserfiche-admin.service';
import { EnvironmentService } from '../_services/environment.service';
import { GroupUser } from '../_models/group-user.model';
import { AuthenticationService } from '../_services/authentication.service';
import { ResponseObject } from '../_models/response-object.model';
import { OutputParam } from '../_models/output-param.model';

@Component({
  selector: 'app-user-administration',
  animations: [
    trigger('myAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        animate(500, style({opacity: 1}))
      ]),
      transition(':leave', [
        animate(0, style({opacity: 0}))
      ])
    ])
  ],
  templateUrl: './user-administration.component.html',
  styleUrls: ['./user-administration.component.scss'],
  providers: [LaserficheAdminService]
})
export class UserAdministrationComponent implements OnInit {

  adminUsers: GroupUser[];
  subsidioUsers: GroupUser[];
  consultaUsers: GroupUser[];

  alerts: any[] = [];

  isSiteAvailable = false;
  loggedInUser = '';
  requestInProgress = false;

  // Show Active TABs
  activeAdminTab = true;
  activeConsultaTab = false;
  activeSubsidioTab = false;

  // Enable Load Buttons
  lookingForAdminUsers = false;
  lookingForConsultaUsers = false;
  lookingForSubsidioUsers = false;

  constructor(private laserficheService: LaserficheAdminService,
              private envService: EnvironmentService,
              private sanitizer: DomSanitizer,
              private authService: AuthenticationService) {
                this.isSiteAvailable = this.envService.adminSite;
                this.loggedInUser = this.authService.currentUserValue.UserName;
               }

  isCollapsed = false;
  dismissible = true;
  siteAvailable = false;

  checkUserToken() {
    // let isTokenValid = false;
    this.authService.checkUserToken()
      .subscribe((response: any) => {

      },
      error => {

      });
  }

  ngOnInit() {
    this.checkUserToken();
    this.adminUsers = [];
    this.subsidioUsers = [];
    this.consultaUsers = [];
    // Load Users
    this.onGetAdminUsers();
    this.onGetConsultaUsers();
    this.onGetSubsidioUsers();
  }

  toggleAdminTab() {
    this.activeAdminTab = !this.activeAdminTab;
    this.activeConsultaTab = false;
    this.activeSubsidioTab = false;
  }

  toggleConsultaTab() {
    this.activeAdminTab = false;
    this.activeConsultaTab = !this.activeConsultaTab;
    this.activeSubsidioTab = false;
  }

  toggleSubsidioTab() {
    this.activeAdminTab = false;
    this.activeConsultaTab = false;
    this.activeSubsidioTab = !this.activeSubsidioTab;
  }

  onGetAdminUsers() {
    this.lookingForAdminUsers = true;
    this.laserficheService.getAdminUsers()
      .pipe(first())
      .subscribe(
        (users: GroupUser[]) => {
          this.adminUsers = users;
          this.lookingForAdminUsers = false;
        },
        error => {
          this.lookingForAdminUsers = false;
        }
      );
  }

  onGetSubsidioUsers() {
    this.lookingForSubsidioUsers = true;
    this.laserficheService.getSubsidioUsers()
      .pipe(first())
      .subscribe(
        (users: GroupUser[]) => {
          this.subsidioUsers = users;
          this.lookingForSubsidioUsers = false;
        },
        error => {
          this.lookingForSubsidioUsers = false;
        }
      );
  }

  onGetConsultaUsers() {
    this.lookingForConsultaUsers = true;
    this.laserficheService.getConsultaUsers()
      .pipe(first())
      .subscribe(
        (users: GroupUser[]) => {
          this.consultaUsers = users;
          this.lookingForConsultaUsers = false;
        },
        error => {
          this.lookingForConsultaUsers = false;
        }
      );
  }

  onAddAdminUser(data: LaserficheTrustee, form: NgForm) {
    this.requestInProgress = true;
    this.laserficheService.addUserToGroup(data.trusteeName, data.groupName, this.loggedInUser)
      .pipe(first())
      .subscribe(
        (response: ResponseObject) => {
          this.requestInProgress = false;
          if (response.success) {
            const outputParams: OutputParam[] = response.responseObject as Array<OutputParam>;
            const actionSuccessful = outputParams.find((param) => {
              return param.tokenName === 'success';
            });
            const actionMessage = outputParams.find((param) => {
              return param.tokenName === 'message';
            });
            form.reset();
            if (actionSuccessful.tokenValue === 'True') {
              setTimeout(
                () => {
                  this.onGetAdminUsers();
                }, 1000);
              alert(`Acción exitosa.\nCuenta ${data.trusteeName} agregado al rol de Administradores.`);
            } else {
              alert(`Acción no exitosa.\n${actionMessage.tokenValue}`);
            }
          } else {
            alert(`Acción no exitosa\nSu solicitud no pudo ser completada. Intente más tarde`);
          }
        },
        (error: HttpErrorResponse) => {
          this.requestInProgress = false;
          // Show Error Message
          alert(`Acción no exitosa.\nSu solicitud no pudo ser procesada. Intente más tarde.`);
        }
      );
  }

  onAddSubsidioUser(data: LaserficheTrustee, form: NgForm) {
    this.requestInProgress = true;
    this.laserficheService.addUserToGroup(data.trusteeName, data.groupName, this.loggedInUser)
      .pipe(first())
      .subscribe(
        (response: ResponseObject) => {
          this.requestInProgress = false;
          if (response.success) {
            const outputParams: OutputParam[] = response.responseObject as Array<OutputParam>;
            const actionSuccessful = outputParams.find((param) => {
              return param.tokenName === 'success';
            });
            const actionMessage = outputParams.find((param) => {
              return param.tokenName === 'message';
            });
            form.reset();
            if (actionSuccessful.tokenValue === 'True') {
              setTimeout(
                () => {
                  this.onGetSubsidioUsers();
                }, 1000);
              alert(`Acción exitosa.\nCuenta ${data.trusteeName} agregado al rol de Funcionarios Subsidio.`);
            } else {
              alert(`Acción no exitosa.\n${actionMessage.tokenValue}`);
            }
          } else {
            alert(`Acción no exitosa\nSu solicitud no pudo ser completada. Intente más tarde`);
          }
        },
        (error: HttpErrorResponse) => {
          this.requestInProgress = false;
          // Show Error Message
          alert(`Acción no exitosa.\nSu solicitud no pudo ser procesada. Intente más tarde.`);
        }
      );
  }

  onAddConsultaUser(data: LaserficheTrustee, form: NgForm) {
    this.requestInProgress = true;
    this.laserficheService.addUserToGroup(data.trusteeName, data.groupName, this.loggedInUser)
      .pipe(first())
      .subscribe(
        (response: ResponseObject) => {
          this.requestInProgress = false;
          if (response.success) {
            const outputParams: OutputParam[] = response.responseObject as Array<OutputParam>;
            const actionSuccessful = outputParams.find((param) => {
              return param.tokenName === 'success';
            });
            const actionMessage = outputParams.find((param) => {
              return param.tokenName === 'message';
            });
            form.reset();
            if (actionSuccessful.tokenValue === 'True') {
              setTimeout(
                () => {
                  this.onGetConsultaUsers();
                }, 1000);
              alert(`Acción exitosa.\nCuenta ${data.trusteeName} agregado al rol de Usuarios de Consulta.`);
            } else {
              alert(`Acción no exitosa.\n${actionMessage.tokenValue}`);
            }
          } else {
            alert(`Acción no exitosa\nSu solicitud no pudo ser completada. Intente más tarde`);
          }
        },
        (error: HttpErrorResponse) => {
          this.requestInProgress = false;
          // Show Error Message
          alert(`Acción no exitosa.\nSu solicitud no pudo ser procesada. Intente más tarde.`);
        }
      );
  }

  onRemoveAdminUser(adminUser: GroupUser) {
    this.requestInProgress = true;
    this.laserficheService.removeUserFromGroup(adminUser.trustee_name, adminUser.group_name, this.loggedInUser)
      .pipe(first())
      .subscribe(
        (response: ResponseObject) => {
          this.requestInProgress = false;
          if (response.success) {
            const outputParams: OutputParam[] = response.responseObject as Array<OutputParam>;
            const actionSuccessful = outputParams.find((param) => {
              return param.tokenName === 'success';
            });
            const actionMessage = outputParams.find((param) => {
              return param.tokenName === 'message';
            });
            if (actionSuccessful.tokenValue === 'True') {
              setTimeout(
                () => {
                  this.onGetAdminUsers();
                }, 1000);
              alert(`Acción exitosa.\nCuenta ${adminUser.trustee_name} eliminada rol de Administradores.`);
            } else {
              alert(`Acción no exitosa.\n${actionMessage.tokenValue}`);
            }
          } else {
            alert(`Acción no exitosa\nSu solicitud no pudo ser completada. Intente más tarde`);
          }
        },
        (error: HttpErrorResponse) => {
          this.requestInProgress = false;
          // Show Error Message
          alert(`Acción no exitosa.\nSu solicitud no pudo ser procesada. Intente más tarde.`);
        }
      );
  }

  onRemoveSubsidioUser(subsidioUser: GroupUser) {
    this.requestInProgress = true;
    this.laserficheService.removeUserFromGroup(subsidioUser.trustee_name, subsidioUser.group_name, this.loggedInUser)
      .pipe(first())
      .subscribe(
        (response: ResponseObject) => {
          this.requestInProgress = false;
          if (response.success) {
            const outputParams: OutputParam[] = response.responseObject as Array<OutputParam>;
            const actionSuccessful = outputParams.find((param) => {
              return param.tokenName === 'success';
            });
            const actionMessage = outputParams.find((param) => {
              return param.tokenName === 'message';
            });
            if (actionSuccessful.tokenValue === 'True') {
              setTimeout(
                () => {
                  this.onGetSubsidioUsers();
                }, 1000);
              alert(`Acción exitosa.\nCuenta ${subsidioUser.trustee_name} eliminada rol de Funcionarios Subsidio.`);
            } else {
              alert(`Acción no exitosa.\n${actionMessage.tokenValue}`);
            }
          } else {
            alert(`Acción no exitosa\nSu solicitud no pudo ser completada. Intente más tarde`);
          }
        },
        (error: HttpErrorResponse) => {
          this.requestInProgress = false;
          // Show Error Message
          alert(`Acción no exitosa.\nSu solicitud no pudo ser procesada. Intente más tarde.`);
        }
      );
  }

  onRemoveConsultaUser(consultaUser: GroupUser) {
    this.requestInProgress = true;
    this.laserficheService.removeUserFromGroup(consultaUser.trustee_name, consultaUser.group_name, this.loggedInUser)
      .pipe(first())
      .subscribe(
        (response: ResponseObject) => {
          this.requestInProgress = false;
          if (response.success) {
            const outputParams: OutputParam[] = response.responseObject as Array<OutputParam>;
            const actionSuccessful = outputParams.find((param) => {
              return param.tokenName === 'success';
            });
            const actionMessage = outputParams.find((param) => {
              return param.tokenName === 'message';
            });
            if (actionSuccessful.tokenValue === 'True') {
              setTimeout(
                () => {
                  this.onGetConsultaUsers();
                }, 1000);
              alert(`Acción exitosa.\nCuenta ${consultaUser.trustee_name} eliminada rol de Usuarios de Consulta.`);
            } else {
              alert(`Acción no exitosa.\n${actionMessage.tokenValue}`);
            }
          } else {
            alert(`Acción no exitosa\nSu solicitud no pudo ser completada. Intente más tarde`);
          }
        },
        (error: HttpErrorResponse) => {
          this.requestInProgress = false;
          // Show Error Message
          alert(`Acción no exitosa.\nSu solicitud no pudo ser procesada. Intente más tarde.`);
        }
      );
  }

  onSubmitForm(form: NgForm) {
    const account = form.value.username;
    let group: string;
    switch (form.value.userRole) {
      case 'ADMIN':
        group = this.laserficheService.adminGroupName;
        this.onAddAdminUser(new LaserficheTrustee(account, group), form);
        break;
      case 'SUBSIDIO':
        group = this.laserficheService.subsidioGroupName;
        this.onAddSubsidioUser(new LaserficheTrustee(account, group), form);
        break;
      case 'CONSULTA':
        group = this.laserficheService.consultaGroupName;
        this.onAddConsultaUser(new LaserficheTrustee(account, group), form);
        break;
    }
  }

}
